import React from 'react';
import { Button, Typography } from 'antd';
import dayjs from 'dayjs';
import { PaymentStatusBadge, EstimateStatusBadge } from '../../components/common/StatusBadge';
import { formatCurrency } from '../../utils/format';
import { isDueDateDisplayed } from '../../utils/documentDisplay';

const { Text } = Typography;

export const buildDashboardInvoiceColumns = (navigate) => [
  {
    title: 'Invoice #',
    dataIndex: 'sale_number',
    key: 'sale_number',
    render: (val, record) => (
      <Button
        type="link"
        style={{ padding: 0, fontWeight: 500 }}
        onClick={() => navigate(`/invoices/${record.public_id ?? record.id}`)}
      >
        {val}
      </Button>
    ),
  },
  {
    title: 'Date',
    dataIndex: 'date_issued',
    key: 'date_issued',
    render: (val) => (val ? dayjs(val).format('MMM D, YYYY') : '—'),
  },
  {
    title: 'Due',
    dataIndex: 'date_due',
    key: 'date_due',
    render: (val, record) => {
      if (!isDueDateDisplayed(record.settings)) return '—';
      if (!val) return '—';
      const overdue = record.status_payment !== 'paid' && dayjs(val).isBefore(dayjs(), 'day');
      return (
        <Text style={{ color: overdue ? 'var(--varexe-danger)' : undefined, fontSize: 13 }}>
          {dayjs(val).format('MMM D, YYYY')}
        </Text>
      );
    },
  },
  {
    title: 'Amount',
    dataIndex: 'amount_total',
    key: 'amount',
    align: 'right',
    render: (val) => formatCurrency(val),
  },
  {
    title: 'Status',
    dataIndex: 'status_payment',
    key: 'status',
    render: (val) => <PaymentStatusBadge status={val} />,
  },
];

export const buildDashboardEstimateColumns = (navigate) => [
  {
    title: 'Estimate #',
    dataIndex: 'estimate_number',
    key: 'estimate_number',
    render: (val, record) => (
      <Button
        type="link"
        style={{ padding: 0, fontWeight: 500 }}
        onClick={() => navigate(`/estimates/${record.public_id ?? record.id}`)}
      >
        {val}
      </Button>
    ),
  },
  {
    title: 'Date',
    dataIndex: 'date_issued',
    key: 'date_issued',
    render: (val) => (val ? dayjs(val).format('MMM D, YYYY') : '—'),
  },
  {
    title: 'Amount',
    dataIndex: 'amount_total',
    key: 'amount',
    align: 'right',
    render: (val) => formatCurrency(val),
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: (val) => <EstimateStatusBadge status={val} />,
  },
];
